module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av0411-69b26ea3743ef993456b57b2360783e6.jpg";